import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import EUserEnum from "@/struct/user/EUserEnum";
import ApiAppVersions from "@/api/ApiAppVersions";
import { Getter } from "vuex-class";
import sweetalert from "sweetalert";
let AppVersionUpdates = class AppVersionUpdates extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = [
            {
                to: "/",
                text: "Главная",
            },
            {
                to: "/secure/admin/app-version-updates",
                text: "Управление обновлениями приложений",
                disabled: true,
            },
        ];
        this.TableHeaders = [
            {
                text: "Версия",
                value: "version",
            },
            {
                text: "Платформа",
                value: "platform",
            },
            {
                text: "Дата публикации",
                value: "released_at",
            },
            {
                text: "Обязательно",
                value: "is_mandatory"
            },
            {
                text: "Требует подтверждения",
                value: "confirmation_required"
            },
            {
                text: "Действие",
                value: "action",
            },
        ];
        this.TableItems = [];
    }
    CanAddAndEditAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin ||
                this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Editor));
    }
    CanDeleteAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin));
    }
    async getAppVersions() {
        try {
            this.TableItems = await ApiAppVersions.GetAllAppVersions(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    ValidateBoolean(value) {
        return value ? "Да" : "Нет";
    }
    EditAppVersion(uuid) {
        this.$router.push(`/secure/admin/app-version-updates/${uuid}/edit`);
    }
    ViewConfirmationHistory(uuid) {
        this.$router.push(`/secure/admin/app-version-updates/${uuid}/confirmation-history`);
    }
    DeleteAppVersion(uuid) {
        sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("offers.confirm_delete"),
            buttons: [
                this.$t("general.no"),
                this.$t("general.yes"),
            ],
        }).then(async (isConfirm) => {
            if (isConfirm == true) {
                const response = await ApiAppVersions.DeleteAppVersionUpdate(ApiEnter.CurrentSessionUUID, uuid);
                if (typeof response == "boolean") {
                    await sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_deleted"),
                        icon: "success",
                    });
                    await this.getAppVersions();
                }
                else {
                    await sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info",
                    });
                }
            }
        });
    }
    mounted() {
        this.getAppVersions();
    }
};
__decorate([
    Getter("getCurrentSessionUser")
], AppVersionUpdates.prototype, "GetCurrentSessionUser", void 0);
AppVersionUpdates = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], AppVersionUpdates);
export default AppVersionUpdates;
